<template>
  <div class="container-padding">
    <div class="school-reviews">
      <h3 class="title">Отзывы</h3>
      <div class="school-reviews__stats">
        <span class="school-reviews__count"> <b>Всего отзывов:</b> {{ reviews.length }} </span>
        <span class="school-reviews__stat">
          <b>Средняя оценка:</b> <ReviewStarsComponent :mark="averageReviewsMark" />
        </span>
      </div>
      <button @click="showReviewCreateModal" type="button" class="btn btn--md btn--main">
        Написать отзыв
      </button>
      <div v-if="reviews && reviews.length" class="school-reviews__list">
        <div v-for="(item, i) in reviews" :key="i" class="school-reviews__item">
          <ReviewComponent :data="item" />
        </div>
      </div>
      <!--      <PaginationComponent-->
      <!--        v-if="showPagination"-->
      <!--        :page="page"-->
      <!--        :total="Math.ceil(news.paginatorInfo.total / first)"-->
      <!--        @change="paginate"-->
      <!--      />-->
    </div>
  </div>
</template>

<script>
import ReviewStarsComponent from "components/reviews/ReviewStarsComponent.vue";
import ReviewComponent from "components/reviews/ReviewComponent.vue";
import ReviewCreateModal from "components/modals/components/ReviewCreateModal.vue";
import LoginModal from "components/modals/components/LoginModal.vue";

export default {
  name: "SchoolReviewsComponent",
  props: {
    reviews: Array,
  },
  computed: {
    // products() {
    //   return this.$store.state.catalog_page.products;
    // },
    // showProducts() {
    //   return this.products && this.products.data && this.products.data.length;
    // },
    // showPagination() {
    //   return this.showProducts && Math.ceil(this.products.paginatorInfo.total / this.first) > 1;
    // },
    isRegistered() {
      return !!this.$store.state.apollo_token || this.$store.state.auth.user;
    },
    averageReviewsMark() {
      if (this.reviews && this.reviews.length) {
        let length = this.reviews.length;
        return (this.reviews.map((r) => parseInt(r.mark)).reduce((a, b) => a + b, 0) / length).toFixed(1);
      }
      return 0;
    },
  },
  methods: {
    showReviewCreateModal() {
      if (this.isRegistered) {
        this.$store.state._modals.push({
          component: ReviewCreateModal,
          options: {
            reviewable_type: "App\\Models\\School",
            canAddVideo: true,
            callback: () => {
              this.$emit("reload");
            },
          },
        });
      } else {
        this.$store.state._modals.push({
          component: LoginModal,
          options: {
            routeAfterLogin: {
              name: this.$route.name,
              params: this.$route.params,
              hash: this.$route.hash,
            },
          },
        });
      }
    },
  },
  components: {
    ReviewStarsComponent,
    ReviewComponent,
  },
};
</script>

<style lang="stylus">
.school-reviews {
  display: flex
  flex-direction: column
  align-items: center
  gap: 30px

  .title {
    margin: 0
  }

  &__stats {
    display: flex
    flex-direction: column
    align-items: center
    text-align: center
  }

  &__stat {
    display: flex
    gap: 10px
    align-items: center
  }

  &__list {
    width: 100%
    display: grid
    grid-template-columns: repeat(3, 1fr)
    grid-gap: 30px
    +below(1200px) {
      grid-template-columns: repeat(2, 1fr)
    }
    +below(820px) {
      grid-template-columns: 1fr
      grid-gap: 20px
    }
  }
}
</style>
